import React, { PureComponent } from 'react';

import './printable.scss';

export default class Invoice extends PureComponent {
  render() {
    return (
      <div className="a4 landscape printable">
        <div className="a4 grid landscape">
          {Array.from({ length: 59 * 42 }, (_, i) => (
            <div className="grid-item" key={i}></div>
          ))}
        </div>
        <div className="a4 landscape page"></div>
      </div>
    );
  }
}
